__turbopack_context__.v({
  "className": "vazirmatn_a708302b-module__eidi0W__className",
  "variable": "vazirmatn_a708302b-module__eidi0W__variable",
});
